import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 active:scale-95 flex items-center justify-center"
          style={{ 
            backgroundColor: '#115d7b',
            boxShadow: '0 4px 20px rgba(17, 93, 123, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#0f5269';
            e.target.style.boxShadow = '0 6px 25px rgba(17, 93, 123, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#115d7b';
            e.target.style.boxShadow = '0 4px 20px rgba(17, 93, 123, 0.3)';
          }}
          aria-label="Scroll to top"
        >
          <ArrowUp className="w-6 h-6 text-white" />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;